const initState = {
    authSuccess: null,
    authError: null,
    email: '',
    numTel: '',
    code: '',
    auth: false
}

const authReducer = (state = initState, action) => {
    switch(action.type) {
        case 'ERREUR_CONNEXION':
            return {
                ...state,
                authSuccess: null,
                authError: 'Connexion échoué'
            }
        case 'CONNEXION_REUSSI':
            return {
                ...state,
                authSuccess: 'Connexion réussi',
                authError: null,
            }
        case 'MAUVAISE_INFO_EMAIL':
            return {
                ...state,
                authSuccess: null,
                authError: "Erreur dans la saisie de l'email"
            }
        case 'MAUVAISE_INFO_NUM':
            return {
                ...state,
                authSuccess: null,
                authError: "Erreur dans la saisie du numéro de téléphone"
            }
        case 'AUCUN_DROIT':
            return {
                ...state,
                authSuccess: null,
                authError: "Vous n'avez aucun droit"
            }
        case 'MAUVAIS_CODE':
            return {
                ...state,
                authSuccess: null,
                authError: "Mauvais code de validation, veuillez réessayer"
            }
        case 'RESET_AUTH_STATE':
            return {
                ...state,
                authSuccess: null,
                authError: null,
            }
        case 'STATE_CODE_TO_FIRESTORE':
            return {
                ...state,
                code: action.code
            }
        case 'CODE_EXPIRE':
            return {
                ...state,
                authSuccess: null,
                authError: "Code expiré, veuillez retourner à la page précédente et resaisir votre adresse email"
            }
        case 'AUTH_STATUS':
            return {
                ...state,
                auth: action.auth
            }
        default:
            return state;
    }
};

export default authReducer;
